import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import ProjectManagement from '../../components/ProjectManagement/ProjectManagement';
import ProjectDetailsPage from './ProjectDetailsPage';

const ProjectsPage = () => {
    const location = useLocation();
    const { id } = useParams();

    // Match the path for details page (e.g., /dashboard/project/:id/details)
    if (location.pathname.match(/^\/dashboard\/project\/.+\/details$/)) {
        return <ProjectDetailsPage />;
    }
    // Default: show project management
    return <ProjectManagement />;
};

export default ProjectsPage;
